// extracted by mini-css-extract-plugin
export var actionText = "_ms-4";
export var container = "_ms-0";
export var leftSection = "_ms-1";
export var rightSection = "_ms-2";
export var settingsButton = "_ms-6";
export var settingsIcon = "_ms-7";
export var shortcut = "_ms-5";
export var shortcutGroup = "_ms-3";